import { Timer1 } from "iconsax-react";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  min-height: 3rem;

  background: ${(props) =>
    props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
    props.theme?.colors?.primary};
`;

export const TimerIcon = styled(Timer1)`
  margin: 0 1.5rem 0 0;
  font-size: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.checkoutTextPrimary};

  @media (max-width: 530px) {
    font-size: 1.25rem;
    margin: 0 0.75rem 0 0;
  }

  @media (max-width: 375px) {
    font-size: 1rem;
    margin: 0 0.5rem 0 0;
  }
`;

export const Paragraph = styled.p`
  margin: 0;

  font-family: Inter;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.5rem;

  color: ${(props) =>
    props.theme?.checkoutStepsOffers?.checkoutTextPrimary} !important;

  @media (max-width: 530px) {
    font-size: 1rem;
    line-height: 1.25rem;
  }

  @media (max-width: 375px) {
    font-size: 0.75rem;
    line-height: 1rem;
  }
`;

export const Strong = styled.strong`
  margin: 0 0 0 1.5rem;

  font-family: Inter;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.checkoutTextPrimary};

  @media (max-width: 530px) {
    font-size: 1rem;
    line-height: 1.25rem;

    margin: 0 0 0 0.75rem;
  }

  @media (max-width: 375px) {
    font-size: 0.75rem;
    line-height: 1rem;

    margin: 0 0 0 0.5rem;
  }
`;
